export const CustomDropdown = ({ name, options, setOptionValue, isDisable, currentValue }) => {
    return (
        <>
            <h2 className="text-uppercase mb-0">
                {name}
            </h2>
            <div className="card">
                <div className="card-body pa-5">
                    <select className="form-control" value={currentValue} onChange={e => setOptionValue(e.target.value)} disabled={isDisable ? true : false}>
                        <option>SELECT</option>
                        {options.map(option => {
                            return <option key={option.ID}>{option.VALUE}</option>
                        })}
                    </select>
                </div>
            </div>
        </>
    )
}